if (!customElements.get('product-image-zoom')) {
  class ProductImageZoom extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.boundKeydown = this.onKeydown.bind(this);
    }

    connectedCallback() {
      this.swiperEl = this.querySelector('.product-image-zoom__swiper');
      this.closeBtn = this.querySelector('.product-image-zoom__close');
      this.prevBtn = this.querySelector('.product-image-zoom__nav--prev');
      this.nextBtn = this.querySelector('.product-image-zoom__nav--next');
      this.slides = Array.from(this.querySelectorAll('.product-image-zoom__slide'));

      if (!this.swiperEl || !this.closeBtn) return;

      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
        return;
      }

      this.closeBtn.addEventListener('click', () => this.close());
      this.addEventListener('click', (e) => {
        if (e.target === this) this.close();
      });

      this.bindGalleryTriggers();
    }

    bindGalleryTriggers() {
      const sectionId = this.dataset.sectionId;
      const gallery = document.getElementById('MediaGallery-' + sectionId);
      if (!gallery) return;

      const triggers = gallery.querySelectorAll('.product__media-toggle');
      triggers.forEach((trigger) => {
        trigger.addEventListener('click', this.onTriggerClick.bind(this), true);
      });
    }

    onTriggerClick(e) {
      const button = e.currentTarget;
      const mediaId = button.getAttribute('data-media-id');
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }
      this.open(mediaId);
    }

    open(mediaId) {
      this.setAttribute('open', '');
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('product-image-zoom-open');

      if (!this.swiper) {
        this.initSwiper();
      }

      if (this.swiper) {
        this.swiper.update();

        if (mediaId) {
          const idx = this.slides.findIndex((s) => s.getAttribute('data-media-id') === mediaId);
          if (idx >= 0) {
            if (this.swiper.params.loop) {
              this.swiper.slideToLoop(idx, 0);
            } else {
              this.swiper.slideTo(idx, 0);
            }
          }
        }
      }

      document.addEventListener('keydown', this.boundKeydown);
      requestAnimationFrame(() => {
        try { this.closeBtn.focus({ preventScroll: true }); } catch (_) {}
      });
    }

    close() {
      this.removeAttribute('open');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('product-image-zoom-open');
      document.removeEventListener('keydown', this.boundKeydown);
      if (this.swiper && this.swiper.zoom) {
        try { this.swiper.zoom.out(); } catch (_) {}
      }
    }

    onKeydown(e) {
      if (e.key === 'Escape') this.close();
    }

    initSwiper() {
      if (typeof window.Swiper === 'undefined') {
        console.warn('[product-image-zoom] Swiper library not available');
        return;
      }

      const config = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: this.slides.length > 1,
        keyboard: { enabled: true },
        mousewheel: { forceToAxis: true, releaseOnEdges: true },
        zoom: { maxRatio: 3, toggle: true },
      };

      if (this.slides.length > 1) {
        config.navigation = {
          prevEl: this.prevBtn,
          nextEl: this.nextBtn,
        };
      }

      try {
        this.swiper = new window.Swiper(this.swiperEl, config);
      } catch (err) {
        console.error('[product-image-zoom] Swiper init failed', err);
      }
    }
  }

  customElements.define('product-image-zoom', ProductImageZoom);
}
